import React, { createContext, useContext, useEffect, useState } from "react";
import APIContext from "../api/api";

import { EcUserDataContext } from "@eclear-ag/ec-common-ui";

import { URLS } from "../../configuration/urls";

const CardsContext = createContext();

export const CardsProvider = ({ children }) => {
  const { getData } = useContext(APIContext);
  const { userData } = useContext(EcUserDataContext);

  const [cardsData, setCardsData] = useState({ year: null, month: null });

  const [cardsDataMonthly, setCardsDataMonthly] = useState(null);

  const getCardsData = async () => {
    const cardsDataYearly = await getData(
      `${URLS.REPORT_ACTUAL_YEAR}${userData.companyId}`
    );
    const res = await getData(
      `${URLS.REPORT_ACTUAL_MONTH}${userData.companyId}`
    );

    setCardsData({
      year: cardsDataYearly ? cardsDataYearly : {},
      month: res ? res : {}
    });
  };

  useEffect(() => {
    if (userData.companyId) {
      getCardsData();
    }
  }, [userData]);

  function getStatus(number) {
    return number > 50 ? "success" : number < 0 ? "error" : "warning";
  }

  function calcPercentage(val1, val2) {
    if (!val1 || !val2) {
      console.error("formatNumber wrong value", val1, val2);
      return 0;
    }
    return (100 / val2) * (val1 - val2);
  }

  return (
    <CardsContext.Provider
      value={{
        cardsData,
        getStatus,
        calcPercentage,
        cardsDataMonthly
      }}
    >
      {children}
    </CardsContext.Provider>
  );
};

export default CardsContext;
